import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { NgpMenu, NgpMenuItem, NgpMenuTrigger } from 'ng-primitives/menu';
import {
  ButtonDirective,
  type ButtonSize,
  type ButtonVariant,
} from '../../primitives/button/button.directive';

@Component({
  selector: 'tc-dropdown',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgpMenu, NgpMenuItem, NgpMenuTrigger, ButtonDirective],
  templateUrl: './dropdown.component.html',
  styleUrl: './dropdown.component.css',
})
export class DropdownComponent {
  readonly label = input('Actions');
  readonly variant = input<ButtonVariant>('default');
  readonly size = input<ButtonSize>('default');
  readonly items = input<Array<{ label: string; action: () => void }>>([]);
}
